import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TENANT_MGMT_ROUTES } from '@app/+state/user-data/user.model';
import { ControlPageFacade, UserDataFacade } from '@ra-state';
import { combineLatest, map, Observable, of, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EulaGuard implements CanActivate, CanActivateChild {
  private readonly controlPageFacade = inject(ControlPageFacade);
  private readonly userDataFacade = inject(UserDataFacade);
  private readonly router = inject(Router);
  private readonly resolvedEulaAccepted$ = combineLatest([
    this.controlPageFacade.isUserFound$,
    this.controlPageFacade.isEulaAccepted$,
  ]).pipe(map(([, isEulaAccepted]) => isEulaAccepted));

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.resolvedEulaAccepted$.pipe(
      take(1),
      switchMap((isEulaAccepted) => {
        if (!isEulaAccepted) {
          return of(true);
        }

        return this.userDataFacade.currentTenantContext$.pipe(
          take(1),
          map((tenantContext) =>
            this.router.createUrlTree([
              tenantContext === 'NotSelected' || tenantContext === 'Personal'
                ? TENANT_MGMT_ROUTES.ORGANIZATIONS
                : '/dashboard',
            ]),
          ),
        );
      }),
    );
  }

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.resolvedEulaAccepted$.pipe(
      take(1),
      map((isEulaAccepted) =>
        isEulaAccepted
          ? true
          : this.router.createUrlTree(['/eula'], {
              queryParams: { postEula: state.url },
            }),
      ),
    );
  }
}
